module.exports = __webpack_public_path__ + "50145685042b4df07a1fd19957275b81.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans/OpenSans-Bold.ttf
// module id = 254
// module chunks = 0